export const formatDate = (dateString: null | Date) => {
  if (!dateString) return "";

  const year = dateString.getFullYear();
  const month = String(dateString.getMonth() + 1).padStart(2, "0");
  const day = String(dateString.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
